export default "/_next/static/images/img4-183753bbc3b001fa30be6038c5910019.png";